var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import TitleImageDescriptionLayout from '@declaration/components/TitleImageDescriptionLayout.vue';
import { CURRENT_CLAIM_TYPE_LAYOUT_COLOR } from '@declaration/layout';
import { quitClaimDeclarationCloseCallback } from '@declaration/helpers/layoutMetaCallback';
import { isElectricalDamageQualification } from '@shared/qualification/qualification';
import { InsurerFeatureFlag, insurerHasFeature } from '@shared/featureFlags/insurerFeatureFlags';
const qualification = namespace('qualification');
const counting = namespace('counting');
const settings = namespace('settings');
let NeedManagement = class NeedManagement extends Vue {
    get selfCareSettings() {
        return this.setting('selfCareSettings');
    }
    get expertNeeded() {
        var _a, _b, _c, _d, _e;
        if ((_a = this.counting) === null || _a === void 0 ? void 0 : _a.notEstimatedPersonalProperty) {
            if (((_e = (_d = (_c = (_b = this.selfCareSettings) === null || _b === void 0 ? void 0 : _b.declaration) === null || _c === void 0 ? void 0 : _c.pages) === null || _d === void 0 ? void 0 : _d.needManagement) === null || _e === void 0 ? void 0 : _e.notEstimatedPersonalProperty) ===
                'manager') {
                return false;
            }
            else
                return true;
        }
        if (isElectricalDamageQualification(this.qualification) &&
            (this.qualification.hasProfessionalIntervened || this.qualification.isAwareOfPublicWorks)) {
            return false;
        }
        return isElectricalDamageQualification(this.qualification) && this.qualification.possibleAppeal;
    }
    get managerNeeded() {
        var _a, _b, _c, _d, _e, _f, _g;
        if (!((_a = this.counting) === null || _a === void 0 ? void 0 : _a.notEstimatedPersonalProperty) ||
            (((_b = this.counting) === null || _b === void 0 ? void 0 : _b.notEstimatedPersonalProperty) &&
                ((_f = (_e = (_d = (_c = this.selfCareSettings) === null || _c === void 0 ? void 0 : _c.declaration) === null || _d === void 0 ? void 0 : _d.pages) === null || _e === void 0 ? void 0 : _e.needManagement) === null || _f === void 0 ? void 0 : _f.notEstimatedPersonalProperty) ===
                    'manager')) {
            return true;
        }
        if (isElectricalDamageQualification(this.qualification) &&
            (this.qualification.hasProfessionalIntervened ||
                this.qualification.isAwareOfPublicWorks ||
                ((_g = this.counting) === null || _g === void 0 ? void 0 : _g.hasOtherPersonalPropertyCategory))) {
            return true;
        }
        return isElectricalDamageQualification(this.qualification) && !this.qualification.possibleAppeal;
    }
    get illustration() {
        var _a, _b, _c, _d;
        if (this.expertNeeded) {
            return require('@declaration/assets/images/appointment/expertOnSite.svg');
        }
        if (this.managerNeeded) {
            if (((_d = (_c = (_b = (_a = this.selfCareSettings) === null || _a === void 0 ? void 0 : _a.declaration) === null || _b === void 0 ? void 0 : _b.pages) === null || _c === void 0 ? void 0 : _c.needManagement) === null || _d === void 0 ? void 0 : _d.managerIllustrationName) ===
                'checklist') {
                return require('@declaration/assets/images/documents/checklist.svg');
            }
            return require('@declaration/assets/images/appointment/managerCall.svg');
        }
        return require('@declaration/assets/images/documents/pause-parcours.svg');
    }
    get title() {
        if (this.expertNeeded) {
            return this.$tc('need_management.title.expert_needed');
        }
        if (this.managerNeeded) {
            return this.$tc('need_management.title.manager_needed');
        }
        return this.$tc('need_management.title');
    }
    get description() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (this.expertNeeded) {
            return this.$tc('need_management.description.expert_needed');
        }
        if (this.managerNeeded) {
            return this.$tc('need_management.description.manager_needed', undefined, {
                phoneNumber: (_d = (_c = (_b = (_a = this.selfCareSettings) === null || _a === void 0 ? void 0 : _a.declaration) === null || _b === void 0 ? void 0 : _b.advisorPhoneNumbers) === null || _c === void 0 ? void 0 : _c.france) !== null && _d !== void 0 ? _d : '01 XX XX XX XX',
            });
        }
        return this.$tc('need_management.description', undefined, {
            phoneNumber: (_h = (_g = (_f = (_e = this.selfCareSettings) === null || _e === void 0 ? void 0 : _e.declaration) === null || _f === void 0 ? void 0 : _f.advisorPhoneNumbers) === null || _g === void 0 ? void 0 : _g.france) !== null && _h !== void 0 ? _h : '01 XX XX XX XX',
        });
    }
    get displayCaseNumber() {
        return insurerHasFeature(InsurerFeatureFlag.DisplayCaseNumberInNeedManagementScreen, this.typeTrigram);
    }
    get continuation() {
        return insurerHasFeature(InsurerFeatureFlag.DisplayContinueButtonInNeedManagementScreen, this.typeTrigram)
            ? 'quit'
            : null;
    }
};
__decorate([
    settings.Getter('setting')
], NeedManagement.prototype, "setting", void 0);
__decorate([
    counting.State('counting')
], NeedManagement.prototype, "counting", void 0);
__decorate([
    qualification.Getter('typeTrigram')
], NeedManagement.prototype, "typeTrigram", void 0);
__decorate([
    qualification.State('qualification')
], NeedManagement.prototype, "qualification", void 0);
NeedManagement = __decorate([
    Component({
        components: {
            TitleImageDescriptionLayout,
        },
        meta: {
            title: 'page.title.confirmation',
            color: CURRENT_CLAIM_TYPE_LAYOUT_COLOR,
            close: quitClaimDeclarationCloseCallback,
            goBack: null,
        },
    })
], NeedManagement);
export default NeedManagement;
